import { AccountPageLayout } from "components/common/AccountPageLayout";
import { TabSpec, TitledTabs } from "components/common/titledTabs";
import { useTenantTranslation } from "hooks/formatters";
import { useMemo, useState } from "react";
import { DailyActivityTab } from "./dailyActivityTab";
import { LabellerOverviewTab } from "./labellerOverviewTab";
import { ReservationSettingsTab } from "./reservationSettings/ReservationSettingsTab";
import { ReviewerOverviewTab } from "./reviewerOverviewTab";

type ManageLabellersTabKey =
  "labellers" | "reviewers" | "dailyActivity" | "reservationSettings";

export const ManageLabellersPage = () => {
  const { t } = useTenantTranslation();
  const [selectedTab, setSelectedTab] =
    useState<ManageLabellersTabKey>("labellers");

  const tabSpecs: TabSpec<ManageLabellersTabKey>[] = useMemo(
    () => [
      {
        title: t("labellers"),
        key: "labellers" as const,
        content: <LabellerOverviewTab />,
      },
      {
        title: t("reviewers"),
        key: "reviewers" as const,
        content: <ReviewerOverviewTab />,
      },
      {
        title: t("dailyActivity"),
        key: "dailyActivity" as const,
        content: <DailyActivityTab />,
      },
      {
        title: t("reservationSettings"),
        key: "reservationSettings" as const,
        content: <ReservationSettingsTab />,
      },
    ],
    [t]
  );

  return (
    <AccountPageLayout title={t("manageLabellers")}>
      <TitledTabs
        tabSpecs={tabSpecs}
        selectedTabKey={selectedTab}
        onChange={setSelectedTab}
      />
    </AccountPageLayout>
  );
};
